<template>
  <el-dialog class="edit-dialog" :close-on-click-modal="false" v-adaptive title="离职申请" :visible.sync="isShowDialog" width="720px" center top="15vh">
    <div v-loading="loading">
      <div class="info">
        <img src="/static/picture/avatar.png" alt="" />
        <div class="right">
          <span class="name">{{ userName }}</span>
          <div class="info-box">
            <div class="info-item">
              <span class="label">所属部门：</span>
              <span>{{ orgName }}</span>
            </div>
            <div class="info-item">
              <span class="label">联系方式：</span>
              <span>{{ telphone }}</span>
            </div>
            <div class="info-item">
              <span class="label">入职时间：</span>
              <span>{{ $common.timesToTime(entryTime) }}</span>
            </div>
          </div>
        </div>
      </div>
      <subTitle title="离职信息" />
      <el-form :model="form" ref="ruleForm" size="medium" label-width="90px">
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="直属领导：" prop="LeaderName" :rules="[{ required: true, message: '请输入直属领导' }]">
              <el-input v-model="form.LeaderName" placeholder="请输入直属领导" clearable />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="担任职务：" prop="Duty" :rules="[{ required: true, message: '请输入担任职务名称' }]">
              <el-input v-model="form.Duty" placeholder="请输入担任职务名称" clearable />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item label="申请日期：" prop="ApplyDateTime" :rules="[{ required: true, message: '离职日期不能为空' }]">
              <el-date-picker style="width: 240px" readonly v-model="form.ApplyDateTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择入职时间" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item label="离职日期：" prop="QuitDate" :rules="[{ required: true, message: '离职日期不能为空' }]">
              <el-date-picker style="width: 240px" clearable v-model="form.QuitDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择入职时间" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item label="离职原因：" prop="QuitCause" :rules="[{ required: true, message: '离职原因不能为空' }]">
              <el-input type="textarea" :rows="4" v-model="form.QuitCause" placeholder="请输入离职原因" clearable />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" style="display: flex; justify-content: center">
      <el-button @click="$emit('update:isShow', false)">取 消</el-button>
      <el-button type="primary" @click="submitEvent" :loading="submitLoading"> 确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getBgUserInfo, getEmpJoin, submitEmpQuit } from '@/http/api';
export default {
  props: ['isShow'],
  data() {
    return {
      loading: false,
      sourceTypeArr: [],
      userName: '',
      orgName: '',
      telphone: '',
      entryTime: '',
      listData: {},
      form: {
        LeaderName: '',
        Duty: '',
        QuitDate: '',
        ApplyDateTime: new Date().toLocaleDateString(),
        QuitCause: '',
        EmpJoinId: '',
      },
      submitLoading: false,
    };
  },
  created() {},
  watch: {
    isShow: {
      handler(val) {
        if (val) {
          this.getData();
          this.$nextTick((_) => {
            this.$refs.ruleForm.clearValidate();
          });
        }
      },
      immediate: true,
    },
  },
  computed: {
    isShowDialog: {
      get() {
        this.submitLoading = false;
        return this.isShow;
      },
      set(v) {
        this.$emit('update:isShow', false);
      },
    },
  },
  methods: {
    getData() {
      this.loading = true;
      let { ID, UserName } = JSON.parse(localStorage.getItem('userInfo') || '{}');
      this.userName = UserName;
      getBgUserInfo(ID)
        .then((res) => {
          let temp = this.$orgList.find((item) => item.ID === res.OrgStructureId);
          this.orgName = (temp && temp.Title) || '';
          this.entryTime = this.$common.timesToTime(res.EntryTime);
          this.telphone = res.Tel;
        })
        .finally(() => (this.loading = false));
    },
    cb() {
      this.$message.success('操作成功');
      this.$emit('update:isShow', false);
    },
    submitEvent() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          submitEmpQuit({
            workflowEntity: this.form,
          })
            .then((res) => {
              if (res.Code) {
                this.$message.success(res.Message);
                this.$emit('update:isShow', false);
              } else {
                this.$message.error(res.Message);
              }
            })
            .finally(() => (this.submitLoading = false));
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.edit-dialog {
  :deep(.el-dialog__body) {
    padding: 16px 24px 0 24px;
  }
  :deep(.el-button) {
    width: 120px;
    padding-top: 10px;
    padding-bottom: 10px;
    & + .el-button {
      margin-left: 32px;
    }
  }
  .info {
    background: #f5fbff;
    display: flex;
    align-items: center;
    padding: 16px 24px;
    img {
      width: 48px;
      margin-right: 16px;
    }
    .right {
      flex: 1;
      .name {
        font-weight: bold;
        color: #3a4151;
      }
      .info-box {
        margin-top: 8px;
        display: flex;
        .info-item {
          color: #3a4151;
          flex: 1;
          .label {
            color: #999;
          }
        }
      }
    }
  }
  :deep(.el-row) {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}
</style>
